import { lazy, Suspense, useMemo } from "react";

export function CommandPalette() {
  const LazyCommandPalette = useMemo(() => lazy(() => import("./command-palette")), []);
  return (
    <Suspense fallback={null}>
      <LazyCommandPalette />
    </Suspense>
  );
}

export { addCommand, addCommands, addRichSearchResult, addRichSearchResults } from "./store";
export * from "./types";
export * from "./ui/List";
